import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-neutral-50 p-4 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-display font-semibold text-neutral-900">
          404
        </h1>
        <p className="text-neutral-600 mt-2">{t('errors.notFound')}</p>
        <Link
          to="/home"
          className="mt-4 inline-block text-primary-600 hover:text-primary-700"
        >
          {t('common.backHome')}
        </Link>
      </div>
    </div>
  )
}
